import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FieldErrorCodes = {
  FieldAnswerForbidden: {
    code: 'field/answer-forbidden',
    explanation:
      'Você não tem permissão para responder a este campo. Isso pode ser devido a restrições na configuração do fluxo.',
    localizations: {},
    message: 'Você não tem permissão para responder este campo.',
    supportingDocs: [
      {
        name: 'Configurações do Fluxo',
        path: '/wiki/docs/pipe/configuration#em-quais-situações-o-formulário-inicial-do-card-pode-ser-atualizado',
      },
    ],
  },
  FieldAnswerForbiddenAfterFirstMove: {
    code: 'field/answer-forbidden-after-first-move',
    explanation:
      'Você não pode responder ao formulário inicial porque o card já foi movido para outra etapa. Isso é devido às configurações do fluxo.',
    localizations: {},
    message:
      'O formulário inicial não pode mais ser respondido, pois o card já foi movido de etapa.',
    supportingDocs: [
      {
        name: 'Configurações do Fluxo',
        path: '/wiki/docs/pipe/configuration#em-quais-situações-o-formulário-inicial-do-card-pode-ser-atualizado',
      },
    ],
  },
  FieldAnswerForbiddenCurrentStageMismatch: {
    code: 'field/answer-forbidden-current-stage-mismatch',
    explanation:
      'Você não pode responder ao formulário da etapa porque o card não está na etapa correspondente. O formulário dessa etapa só pode ser respondido quando o card estiver na etapa na qual ele pertence.',
    localizations: {},
    message:
      'O formulário da etapa não pode ser respondido, pois o card não está na etapa correspondente.',
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration#formulário-da-etapa',
      },
    ],
  },
  FieldAnswerForbiddenInStage: {
    code: 'field/answer-forbidden-in-stage',
    explanation:
      'Você não pode responder ao formulário inicial nesta etapa. Isso é devido às configurações do fluxo.',
    localizations: {},
    message: 'O formulário inicial não pode ser respondido nesta etapa.',
    supportingDocs: [
      {
        name: 'Configurações do Fluxo',
        path: '/wiki/docs/pipe/configuration#em-quais-situações-o-formulário-inicial-do-card-pode-ser-atualizado',
      },
    ],
  },
  FieldConditionIncorrectReference: {
    code: 'field/condition-incorrect-reference',
    explanation:
      'Um campo do formulário está com a condicional apontando para um título incorreto ou inexistente. Altere a tarefa da condicional e selecione uma tarefa existente.',
    localizations: {},
    message: 'Um ou mais campos condicionais estão referencido a tarefas com títulos incorretos',
  },
  FieldForbiddenOperationForType: {
    code: 'field/forbidden-operation-for-type',
    explanation:
      'A operação que você está tentando realizar não é permitida para o tipo deste campo. Por exemplo, tentar pesquisar por registros em um campo que não seja de banco de dados.',
    localizations: {},
    message: 'A operação não é permitida para o tipo deste campo.',
    supportingDocs: [
      {
        name: 'Tipos de Perguntas',
        path: '/wiki/docs/pipe/forms#tipos-de-perguntas',
      },
    ],
  },
  FieldInvalidValue: {
    code: 'field/invalid-value',
    explanation:
      'O valor fornecido para um campo no formulário é inválido. Cada tipo de campo tem seus próprios requisitos de formato e validação. Alguns exemplos incluem datas em formato incorreto, números fora do intervalo permitido ou texto que excede o comprimento máximo.',
    localizations: {},
    message:
      'O valor informado em um dos campos não atende aos requisitos de formato. Verifique se datas, números e textos estão no formato correto e tente novamente.',
  },
  FieldMissingConfiguration: {
    code: 'field/missing-configuration',
    explanation:
      'A configuração necessária para este campo está faltando. Verifique a configuração do campo no esquema do formulário.',
    localizations: {},
    message: 'A configuração necessária para este campo está incompleta ou ausente.',
  },
  FieldNotFound: {
    code: 'field/not-found',
    explanation: 'O campo que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Campo não encontrado.',
  },
  FieldRequired: {
    code: 'field/required',
    explanation:
      'Um campo obrigatório no formulário não foi preenchido. O formulário não pode ser enviado até que todos os campos obrigatórios sejam preenchidos.',
    localizations: {},
    message:
      'Um ou mais campos obrigatórios não foram preenchidos. Procure pelos campos marcados com asterisco (*) e complete as informações necessárias.',
    supportingDocs: [
      {
        name: 'Formulários',
        path: '/wiki/docs/pipe/forms',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'field'>;
